var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("pilot-dialog", {
    attrs: { title: _vm.$t("pilotInfluencer") },
    scopedSlots: _vm._u([
      {
        key: "header-left",
        fn: function () {
          return [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.bottom",
                    value: {
                      content: _vm.$t("back"),
                    },
                    expression: "{\n        content: $t('back')\n      }",
                    modifiers: { bottom: true },
                  },
                ],
                staticClass: "pilot-tooltip-btn",
                on: { click: _vm.back },
              },
              [_c("i", { staticClass: "isif isif-pilot-short-left" })]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "header-right",
        fn: function () {
          return [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.bottom",
                    value: {
                      content: _vm.$t("close"),
                    },
                    expression: "{\n        content: $t('close')\n      }",
                    modifiers: { bottom: true },
                  },
                ],
                staticClass: "pilot-tooltip-btn",
                on: { click: _vm.close },
              },
              [_c("i", { staticClass: "isif isif-close" })]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.pilotInfluencer
              ? _c("div", { staticClass: "pilot-influencer" }, [
                  _c("div", { staticClass: "pilot-influencer__avatar" }, [
                    _vm.pilotInfluencer.portraitImage
                      ? _c("img", {
                          attrs: { src: _vm.pilotInfluencer.portraitImage },
                        })
                      : _c("i", { staticClass: "isif isif-man" }),
                  ]),
                  _vm._v(" "),
                  _vm.pilotInfluencer.name
                    ? _c("div", { staticClass: "pilot-influencer__title" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.pilotInfluencer.name) +
                            "\n      "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "pilot-tours" }, [
              _c("div", { staticClass: "pilot-tours__title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("pilotTourBy", {
                        influencer: _vm.pilotInfluencer.name,
                      })
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "horizontal-drag-scrolling",
                      rawName: "v-horizontal-drag-scrolling",
                      value: {
                        startX: _vm.contentStartX,
                        scrollLeft: _vm.contentScrollLeft,
                        isMousedown: _vm.isContentMousedown,
                      },
                      expression:
                        "{\n          startX: contentStartX,\n          scrollLeft: contentScrollLeft,\n          isMousedown: isContentMousedown\n        }",
                    },
                  ],
                  staticClass: "pilot-tours__content",
                },
                _vm._l(_vm.pilotTours, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.objectId,
                      staticClass: "pilot-tour-card",
                      class: {
                        "pilot-tour-card--active":
                          item.objectId === _vm.tourId && _vm.isPilotPlaying,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pilot-tour-card__thumbnail",
                          on: {
                            click: function ($event) {
                              return _vm.toPilotTour(item.objectId)
                            },
                          },
                        },
                        [
                          item.pilotThumbnail || item.buildingThumbnail
                            ? _c("img", {
                                attrs: {
                                  src:
                                    item.pilotThumbnail ||
                                    item.buildingThumbnail,
                                },
                              })
                            : _c("i", { staticClass: "isif isif-man" }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "pilot-tour-card__body" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.name) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "subtitle" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.ownerName) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "pilot-tour-card__control-btn",
                          on: {
                            click: function ($event) {
                              return _vm.togglePilotPlayerStatus(item.objectId)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "isif isif-pilot-play",
                            class: {
                              "isif-pilot-pause":
                                _vm.isPilotPlaying &&
                                item.objectId === _vm.tourId,
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }